<div class="w-full">
  @if (label) {
    <label class="mb-2 block text-sm font-medium text-slate700">
      {{ label }}
      @if (required) {
        <span class="ml-1 text-red600">*</span>
      }
    </label>
  }

  <div
    class="flex"
    [ngClass]="direction === 'row' ? 'flex-row flex-wrap gap-3' : 'flex-col gap-2'"
    role="radiogroup"
    [attr.aria-label]="label || 'Radio group'"
    >
    @for (option of options; track trackByValue($index, option)) {
      <label
        class="block rounded-lg border bg-white px-3 py-2 transition-all duration-200"
			[ngClass]="{
				'border-blue500 ring-2 ring-blue100': isOptionSelected(option) && !isOptionDisabled(option),
				'border-slate300 hover:border-slate400': !isOptionSelected(option) && !isOptionDisabled(option),
				'cursor-not-allowed border-slate200 bg-slate100 opacity-60': isOptionDisabled(option),
				'cursor-pointer': !isOptionDisabled(option)
			}"
        >
        <div class="flex items-center gap-3">
          <input
            type="radio"
            [name]="groupName"
            [value]="option.value"
            [formControl]="resolvedControl"
            [disabled]="isOptionDisabled(option)"
            [attr.aria-invalid]="shouldShowError"
            (mousedown)="onOptionMouseDown($event, option)"
            (change)="onSelectionChange(option)"
            (blur)="markAsTouched()"
            class="h-4 w-4 border-slate300  disabled:cursor-not-allowed"
            />
          <span class="text-sm text-slate800" [ngClass]="{ 'text-slate500': isOptionDisabled(option) }">
            {{ option.label }}
          </span>
        </div>
      </label>
    }
  </div>

  <div class="mt-1.5 min-h-5 text-xs">
    @if (shouldShowError) {
      <p class="text-red600">{{ firstErrorMessage }}</p>
    }
  </div>
</div>
